define('controllers/conversations/Podio.Controllers.Conversations.Show',['require','underscore','jquery','translate','lib/backbone/Backbone.PodioController','lib/Podio.PresenceBus','lib/Podio.Push','models/Podio.Models.User','collections/Podio.Collections.Contacts','collections/Podio.Collections.Subscriptions','controllers/conversations/Podio.Controllers.Conversations.New','controllers/peoplefinder/Podio.Controllers.PeopleFinder.Main','controllers/presence/Podio.Controllers.PresenceBar','lib/view_helpers/base','lib/Podio.UI.Modal','lib/Podio.UI','lib/Podio.Event','lib/Podio.Store.Text'],function(require) {

  var _ = require('underscore');
  var $ = require('jquery');
  var t = require('translate');
  var PodioController = require('lib/backbone/Backbone.PodioController');
  var PresenceBus = require('lib/Podio.PresenceBus');
  var PodioPush = require('lib/Podio.Push');

  var UserModel = require('models/Podio.Models.User');
  var ContactsCollection = require('collections/Podio.Collections.Contacts');
  var SubscriptionsCollection = require('collections/Podio.Collections.Subscriptions');

  var ControllerConversationNew = require('controllers/conversations/Podio.Controllers.Conversations.New');
  var ControllerPeopleFinderMain = require('controllers/peoplefinder/Podio.Controllers.PeopleFinder.Main');
  var PresenceBarController = require('controllers/presence/Podio.Controllers.PresenceBar');

  var viewHelpers = require('lib/view_helpers/base');

  var modals = require('lib/Podio.UI.Modal');
  var podioUI = require('lib/Podio.UI');
  var podioEvent = require('lib/Podio.Event');

  var textStore = require('lib/Podio.Store.Text');

  return PodioController.extend({

    initialize: function(options) {
      this._super();
      _.bindAll(this, 'onAddPeopleClicked', 'onMessageCreateSuccessful', 'onLeaveConversationClicked', 'onConversationLeft', 'onTaskCreated', 'onPushEventAdded', 'deleteMessage','onMessageDeletePushed', 'getTheModelToDelete');

      this.mainViewClass = options.mainViewClass;         /* Podio.Views.Conversations.Show in case of the message page */
      this.elmMainViewTarget = options.elmMainViewTarget;
      this.presenceFeatures = options.presenceFeatures || ['typing', 'viewers'];

      this.conversationsCollectionController = options.conversationsCollectionController;

      this.userModel = new UserModel();

      this._bindEvents();
      this._makeNewMainView();
    },

    _bindEvents: function() {
      this.listenTo(this.eventBus, 'showConversation:addPeople', this.onAddPeopleClicked);
      this.listenTo(this.eventBus, 'showConversation:leaveConversation', this.onLeaveConversationClicked);
      this.listenTo(this.eventBus, 'composer:changed', this.storeText, this);
      this.listenTo(this.eventBus, 'composer:submit', this.onNewMessageSubmitted);
      this.listenTo(this.eventBus, 'composer:submitToggleChanged', this.onCommentComposerSubmitToggleChanged, this);
      this.listenTo(this.eventBus, 'composer:resized', this.onCommentComposerResized, this);
      this.listenTo(this.eventBus, 'conversationsCollection:eventAdded', this.onPushEventAdded);
      this.listenTo(this.eventBus, 'conversationsCollection:leftConversation', this.onPushLeftConversation);
      this.listenTo(this.eventBus, 'chatMainView:navigationChanged', this.onNavigationChanged);
      this.listenTo(this.eventBus, 'showConversation:eventRendered', this.onConversationEventRendered, this);
      this.listenTo(this.eventBus, 'showConversation:beforeEventRendered', this.onBeforeConversationEventRendered, this);
      this.listenTo(this.eventBus, 'chat:delete', this.deleteMessage, this);
      podioEvent.bind(podioEvent.Types.taskComplete, this.onTaskCreated);
      PodioPush.on('conversation', 'conversation_message_delete', this.onMessageDeletePushed);
    },

    initPresenceBar: function() {
      this.disposePresenceBar();

      this.presenceBarController = new PresenceBarController({
        eventBus: this.eventBus,
        model: this.conversation,
        stickinessEnabled: false,
        shouldRenderNewCommentsInfo: false,
        subscriptions: new SubscriptionsCollection(),
        contactsCollection: new ContactsCollection(),
        refType: 'conversation',
        features: this.presenceFeatures,
        elmContainer: $('.conversation-presence-bar-wrapper')
      });

    },

    disposePresenceBar: function() {
      if (this.presenceBarController) {
        this.presenceBarController.dispose();
      }
    },

    onMessageDeletePushed: function(pushData) {
      model = this.getTheModelToDelete(pushData.data_ref.id);
      if (model && model.get('data')) {
        this.deleteMessage(model);
      }
    },

    deleteMessage : function(model) {
      this.conversationEvents.remove(model);
      this._makeNewMainView();
      this.mainView.setConversation(this.conversation, this.conversationEvents);
      this.trigger('showConversation:messageDeleted', this.conversation);
      this.mainView.render(null, {});
    },

    getTheModelToDelete: function(messageId) {
      return this.conversationEvents.find(function(model) {
        if (model && model.get('data'))
          return (model.get('data').id == messageId);
      });
    },

    _makeNewMainView: function() {
      if (this.mainView) {
        this.mainView.dispose();
      }

      this.mainView = new this.mainViewClass({
        elmTarget: this.elmMainViewTarget,
        eventBus: this.eventBus,
        model: this.conversation
      });
    },

    _getOtherParticipantsForPicker: function(conversation) {
      return conversation.getOtherParticipants().map(function(participant) {
        return {
          ref_type: 'user',
          id: participant.get('user_id') || participant.get('id'),
          name: participant.get('name'),
          avatar: viewHelpers.avatar_url_for(participant, 'tiny')
        };
      });
    },

    // Open new conversation modal with the two participants preselected
    // Immidiately pop the people finder
    _newGroupConversationFromDirect: function(conversation) {
      if (this.newConversationController) {
        this.newConversationController.dispose();
      }

      this.newConversationController = ControllerConversationNew.getSingleton({
        eventBus: this.eventBus,
        prePopulate: this._getOtherParticipantsForPicker(conversation),
        popPeopleFinder: true,
        conversationsCollectionController: this.conversationsCollectionController
      });
      this.newConversationController.show();
    },

    _addParticipants: function(conversation) {
      this.peopleFinder = new ControllerPeopleFinderMain([
        {type: 'podio', visible: true, excludeSelf: true},
        {type: 'mail', visible: true},
        {type: 'linkedAccounts', visible: true, contactable: true}
      ]);

      this.peopleFinder.signals.onDone.add(this.onPeopleFinderDone, this);
      this.peopleFinder.signals.onClose.add(this._disposePeopleFinder, this);

      // Prepopulate finder with already selected participants
      var finderItems = {
        user: this._getOtherParticipantsForPicker(conversation)
      };
      this.peopleFinder.populate(finderItems);

      this.peopleFinder.show();
    },

    _disposePeopleFinder: function() {
      this.peopleFinder.signals.onDone.remove(this.onPeopleFinderDone);
      this.peopleFinder.signals.onClose.remove(this._disposePeopleFinder);
      this.peopleFinder.destroy();
      delete this.peopleFinder;
    },

    // Ensure that the conversation events has the id of the conversation
    _ensureConversationEvents: function() {
      if (this.conversationEvents) {
        this.conversationEvents.setConversationId(this.conversation.get('id'));
      }
    },

    _initConversationFromComposer: function(data) {
      var parcipantUserIds = this.conversation.get('participants').map(function(participant) {
        return participant.get('id');
      });

      this.conversation.set('text', data.value);
      this.conversation.set('file_ids', data.file_ids);
      this.conversation.set('participants', []);
      this.conversation.set('participant_list', parcipantUserIds);
    },

    onAddPeopleClicked: function(conversation) {
      if (conversation.isDirect()) {
        this._newGroupConversationFromDirect(conversation);
      } else {
        this._addParticipants(conversation);
      }
    },

    onLeaveConversationClicked: function(conversation) {
      var self = this;
      modals.showConfirm(t('Leave conversation #conversation'), t('Are you sure you want to leave this conversation? If you change your mind, another conversation participant will have to add you back in. #conversations'), null, {yes: t('Yes, leave #conversations'), no: t('Cancel') }, function() {
        self.indicateConversationLoading();
        conversation.leave().done(self.onConversationLeft.curry(conversation));
      });
    },

    onConversationLeft: function(conversation) {
      this.removeConversation();
      this.eventBus.trigger('showConversation:leftConversation', conversation);
    },

    onPeopleFinderDone: function(data) {
      var participantMap = _.flatten(_.map(data.attributes, function(coll, key) {
        return coll ? _.map(coll, function(ref) {
          if ( ref.ref_type === 'external' ) {
            return { type: 'external', id: { linked_account_id: ref.linked_account_id, external_contact_id: ref.external_contact_id } };
          } else {
            return { type: ref.ref_type, id: ref.id };
          }
        } ) : [];
      }));
      this.eventBus.trigger('showConversation:addParticipants', this.conversation, participantMap);

      this._disposePeopleFinder();
    },

    onConversationChanged: function(model, options) {
      // some views like the audioVideo chat don't have a header
      if (this.mainView.renderHeader) {
        this.mainView.renderHeader();
      }
    },

    retrieveText: function() {
      return textStore.get('conversation', this.conversation.get('id'));
    },

    storeText: function(text) {
      textStore.set('conversation', this.conversation.get('id'), text);
    },

    onNewMessageSubmitted: function(data) {
      this.conversationsCollectionController.createEvent(data, this.conversation.get('id')).done(this.onMessageCreateSuccessful);
      this.trigger('showConversation:messageSubmitted', this.conversation);
    },

    onCommentComposerSubmitToggleChanged: function(isEnabled) {
      if (isEnabled) {
        this.userModel.setProperty('comment_composer_return_submit', true);
      } else {
        this.userModel.removeProperty('comment_composer_return_submit');
      }
    },

    onCommentComposerResized: function() {
      this.mainView.scrollToBottom(false);
    },

    onMessageCreateSuccessful: function() {
      this.storeText(null);

      this.mainView.restoreComposer();
    },

    onTaskCreated: function(e, responseData) {
      // Only the conversations page view needs to reload tasks
      if (this.mainView.onTaskCreated) {
        this.mainView.onTaskCreated();
      }
    },

    onPushEventAdded: function(conversation, eventId, createdOn, totalUnreadCount) {
      var self = this;

      // Only react if we are currently displaying this conversation
      if (this.conversation && this.conversation.id === conversation.id) {
        this._ensureConversationEvents();
        var promise = this.conversationsCollectionController.handleMessagePushEvent(this.conversationEvents, eventId, createdOn);
        promise.done(function(event) {
          if (self.conversation.id === conversation.id) {
            // The conversation might have changed while the events were loading
            self.mainView.renderEvent(event, self.conversationEvents, {fresh: true});
          }
        });
      } else {
        this.conversationsCollectionController.clearEventsCache(conversation.id);
      }
    },

    onPushLeftConversation: function(conversationId) {
      // Only react if we are currently displaying this conversation
      if (this.conversation && this.conversation.id === conversationId) {
        this.removeConversation();
      }
    },

    onNavigationChanged: function(menuItem) {
      // If user navigates to the contact list in the chat pane, clear up the conversation since it is not shown any more
      if (menuItem === 'contactList') {
        this.removeConversation();
      }
    },

    onBeforeConversationEventRendered: function() {
      this.wasComposerFullyVisible = this.mainView.isComposerFullyVisible();
    },

    onConversationEventRendered: function(conversationEvent) {
      this.triggerChatModeLogic(this.wasComposerFullyVisible);
    },

    triggerChatModeLogic: function(wasComposerFullyVisibleRender) {
      if (wasComposerFullyVisibleRender) {

        var self = this;

        _.defer(function() {
          self.mainView.scrollToBottom(true);
        });

      }
    },

    indicateConversationLoading: function() {
      this.mainView.renderWaiting();
    },

    setConversation: function(conversation, collection) {
      // Unbind any previous conversation
      if (this.conversation) {
        this.conversation.off('change', this.onConversationChanged);
      }
      this.unregisterRealTime();

      // Set model and collection
      this.conversation = conversation;
      this.conversationEvents = collection;

      // Bind on the new conversation
      this.conversation.on('change', this.onConversationChanged, this);

      this.registerRealTime();

      // Dispose old view and make a new for this conversation
      this._makeNewMainView();
      this.mainView.setConversation(this.conversation, this.conversationEvents);

      // Set the global context so new tasks are created on this conversation
      // Should only happen on conversation page.
      if (podioUI.context() && podioUI.context().context_type === 'conversation') {
        podioUI.setContext('conversation', this.conversation.get('id'));
      }
    },

    renderConversation: function(options) {
      this.mainView.render(null, options);
      this.mainView.initPagination();
      this.mainView.loadHeightFillingItems();
      this.initPresenceBar();

      var oldText = this.retrieveText();
      if (oldText) {
        this.mainView.setComposerInput(oldText);
      }
    },

    removeConversation: function() {
      this.unregisterRealTime();
      this.disposePresenceBar();
      this.mainView.renderEmpty();

      // Clear the global context so new tasks are not created on a specific conversation
      // Should only happen on conversation page.
      if (podioUI.context() && podioUI.context().context_type === 'conversation') {
        podioUI.clearContext();
      }

      // Unbind conversation
      if (this.conversation) {
        this.conversation.off('change', this.onConversationChanged);
      }

      // Remove model and collection
      delete this.conversation;
      delete this.conversationEvents;
    },

    registerRealTime: function() {
      if (this.conversation.get('presence')) {
        PresenceBus.setReference(this.conversation.get('presence'));
      }
      if (this.conversation.get('push')) {
        PodioPush.subscribeToChannel(this.conversation.get('push'));
      }
    },

    unregisterRealTime: function() {
      if (this.conversation) {
        if (this.conversation.get('push')) {
          PodioPush.unsubscribeFromChannel(this.conversation.get('push'));
        }
        if (this.conversation.get('presence')) {
          PresenceBus.clearReference(this.conversation.get('presence'));
        }
      }
    },

    scrollToBottom: function() {
      this.mainView.scrollToBottom();
    },

    dispose: function() {
      this._super();
      //this.stopListeningToEventBus();
      this.stopListening();
      this.unregisterRealTime();
      this.disposePresenceBar();

      podioEvent.unbind(podioEvent.Types.taskComplete, this.onTaskCreated);

      if (this.mainView) {
        this.mainView.dispose();
        delete this.mainView;
      }
    }


  });

});

